import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SearchInput } from '@/components/common/SearchInput';
import { TableColumnVisibilityMenu } from '@/components/common/TableColumnVisibilityMenu';
import { TableGroupMenu } from '@/components/common/TableGroupMenu';
import { TableSortMenu } from '@/components/common/TableSortMenu';
import IndicatorHeader from '@/components/indicators/IndicatorHeader';
import { columnsDef, defaultColumnVisibility } from '@/components/indicators/index/IndicatorData';
import IndicatorFilterDrawer from '@/components/indicators/index/IndicatorFilterDrawer';
import IndicatorTable from '@/components/indicators/index/IndicatorTable';

const collecteSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(25),
  filter: z.string().catch(''),
  sort: z.string().catch(''),
  columns: z.string().catch(''),
  group_by: z.string().catch(''),
});

export const Route = createFileRoute('/_layout/$slug/indicators/')({
  component: RouteComponent,
  validateSearch: (search) => collecteSearchSchema.parse(search),
});

function RouteComponent() {
  const { sort, search, group_by, filter, columns } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <VStack maxW="100%" maxH="100vh" overflow={'hidden'} flexGrow={1} gap={0}>
      <IndicatorHeader />
      <Box p="1rem" w="full">
        <Box p="3px" bg="#F1F7FA" justifyContent="center" w="100%" borderRadius={'md'}>
          <Flex bg="#F1F7FA" justifyContent="center">
            <HStack justifyContent="space-between" width="100%" p="1rem" bg="white" wrap="wrap">
              <SearchInput search={search} />
              <Flex gap={4} justifyContent={'flex-end'} flexGrow={1}>
                <IndicatorFilterDrawer filter={filter} />
                <TableSortMenu sort={sort} navigate={navigate} columnsDef={columnsDef} />
                <TableGroupMenu groupBy={group_by} navigate={navigate} columnsDef={columnsDef} />
                <TableColumnVisibilityMenu
                  columns={columns}
                  columnsDef={columnsDef}
                  defaultColumnVisibility={defaultColumnVisibility}
                  navigate={navigate}
                />
              </Flex>
            </HStack>
          </Flex>
          <IndicatorTable />
        </Box>
      </Box>
    </VStack>
  );
}
